import { gql } from '@apollo/client'
import { CHATBOT_QUICK_PROMPT_FIELDS } from './fragments/chatbot_quick_prompt'

export const ALL_CHATBOT_QUICK_PROMPTS = gql`
  ${CHATBOT_QUICK_PROMPT_FIELDS}
  query allChatbotQuickPrompts {
    allChatbotQuickPrompts {
      quickPrompts {
        ...ChatbotQuickPromptFields
      }
    }
  }
`
